
export const RELATORIOS_DESIGN = {
    page: {
        container: "flex flex-col w-full gap-5 mt-5 px-4 md:px-8 lg:px-12 pb-8 max-w-[1600px] mx-auto animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            left: "flex items-center gap-4",
            iconBox: "w-12 h-12 rounded-2xl bg-violet-50 flex items-center justify-center",
            icon: "text-violet-600",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-0.5",
            right: "flex items-center gap-3",
        },
    },
    // Two-column layout (sidebar + content)
    twoColumn: {
        container: "flex gap-6",
        sidebar: "w-[280px] flex-shrink-0 space-y-3 sticky top-0 self-start",
        content: "flex-1 min-w-0",
    },
    // Sidebar stat cards (Builder pattern)
    sidebarStat: {
        card: "bg-white rounded-xl border border-gray-100",
        cardContent: "p-4",
        row: "flex items-center gap-3",
        iconBox: {
            base: "p-2 rounded-lg flex-shrink-0",
            blue: "bg-blue-100",
            amber: "bg-amber-100",
            green: "bg-green-100",
            red: "bg-red-100",
            violet: "bg-violet-100",
            gray: "bg-gray-100",
            orange: "bg-orange-100",
        },
        icon: {
            blue: "w-4 h-4 text-blue-600",
            amber: "w-4 h-4 text-amber-600",
            green: "w-4 h-4 text-green-600",
            red: "w-4 h-4 text-red-600",
            violet: "w-4 h-4 text-violet-600",
            gray: "w-4 h-4 text-gray-600",
            orange: "w-4 h-4 text-orange-600",
        },
        label: "text-[10px] text-gray-500 font-medium leading-tight",
        value: "text-xl font-bold text-gray-800",
    },
    // Card wrapper for table column
    tableCard: {
        container: "bg-white rounded-xl border border-gray-100 flex flex-col max-h-[calc(100vh-200px)]",
        cardContent: "p-0 flex flex-col min-h-0 flex-1",
        filterBar: "px-5 py-4 border-b border-gray-100 flex items-center justify-between shrink-0",
        filterTitle: "text-sm font-semibold text-gray-700",
        filterActions: "flex items-center gap-2",
    },
    stats: {
        grid: "grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-3",
        card: "bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow",
        iconBox: {
            base: "w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0",
            blue: "bg-blue-50",
            amber: "bg-amber-50",
            green: "bg-green-50",
            red: "bg-red-50",
            violet: "bg-violet-50",
            gray: "bg-gray-50",
            orange: "bg-orange-50",
        },
        icon: {
            blue: "text-blue-600",
            amber: "text-amber-600",
            green: "text-green-600",
            red: "text-red-600",
            violet: "text-violet-600",
            gray: "text-gray-600",
            orange: "text-orange-600",
        },
        value: "text-xl font-bold text-gray-900",
        label: "text-xs text-gray-500",
    },
    filters: {
        container: "flex flex-row flex-wrap items-end gap-4",
        group: "flex flex-col gap-1",
        label: "text-xs font-semibold text-gray-500 uppercase tracking-wider",
    },
    table: {
        container: "bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden",
        header: "border-b border-gray-100 bg-gray-50/50",
        headerCell: "text-xs font-semibold text-gray-500 uppercase tracking-wider",
        row: {
            base: "border-b last:border-b-0 border-gray-100 hover:bg-gray-50/50 transition-colors",
        },
        cell: "text-sm text-gray-700",
        cellBold: "text-sm font-semibold text-gray-900",
    },
    pagination: {
        container: "px-5 py-3 border-t border-gray-100 flex items-center justify-between shrink-0",
        text: "text-xs text-gray-500",
        buttons: "flex items-center gap-1",
        pageInfo: "text-xs text-gray-500 px-2",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-12 text-center",
        iconBox: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4",
        icon: "w-8 h-8 text-gray-400",
        title: "text-lg font-semibold text-gray-900 mb-1",
        description: "text-gray-500 max-w-sm mb-6",
    },
    badges: {
        nota: {
            high: "text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border-green-200 px-2 py-0.5 rounded-full border",
            medium: "text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border-amber-200 px-2 py-0.5 rounded-full border",
            low: "text-xs font-medium flex items-center gap-1.5 bg-red-50 text-red-700 border-red-200 px-2 py-0.5 rounded-full border",
        },
        status: {
            aberto: "text-xs font-medium flex items-center gap-1.5 bg-blue-50 text-blue-700 border-blue-200",
            pendente: "text-xs font-medium flex items-center gap-1.5 bg-amber-50 text-amber-700 border-amber-200",
            concluido: "text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border-green-200",
            cancelado: "text-xs font-medium flex items-center gap-1.5 bg-gray-50 text-gray-600 border-gray-200",
            recusado: "text-xs font-medium flex items-center gap-1.5 bg-red-50 text-red-700 border-red-200",
            atrasado: "text-xs font-medium flex items-center gap-1.5 bg-orange-50 text-orange-700 border-orange-200",
        },
        dot: {
            blue: "w-1.5 h-1.5 rounded-full bg-blue-500",
            amber: "w-1.5 h-1.5 rounded-full bg-amber-500",
            green: "w-1.5 h-1.5 rounded-full bg-green-500",
            gray: "w-1.5 h-1.5 rounded-full bg-gray-400",
            red: "w-1.5 h-1.5 rounded-full bg-red-500",
            orange: "w-1.5 h-1.5 rounded-full bg-orange-500",
        },
    },
};
